import React, { ReactNode } from 'react';
import { FieldInputProps } from 'react-final-form';
import { TFunction } from 'i18next';
import { isNil } from 'ramda';
import {
  DropdownMenuItem,
  DropdownMenuItemInner,
} from '~web/view/components/ui/form/dropdown-menu-item.component';
import { SelectFieldOption } from '~common/components/select.component';
//TODO: Move this icon to common module
import { CheckMarkIcon } from '~web/view/components/ui/icon/check-mark.icon';
import { Span } from '~common/components/span.component';

//TODO: Change these to components
export const selectOptionsDesktop = (
  options: SelectFieldOption[],
  input: FieldInputProps<string>,
): ReactNode[] =>
  options?.map((option) => (
    <DropdownMenuItem value={option.value} key={option.value}>
      <DropdownMenuItemInner>
        <Span>{option.name}</Span>
        {option.value === input.value && <CheckMarkIcon width={15} height={12} />}
      </DropdownMenuItemInner>
    </DropdownMenuItem>
  ));

export const selectOptionsMobile = (options: SelectFieldOption[]): ReactNode => (
  <>
    <option value={''} hidden />
    {options?.map((option) => (
      <option value={option.value} key={option.value}>
        {option.name}
      </option>
    ))}
  </>
);
/**
 * A shortcut that maps the passed enum value to both value and name field
 * @param value
 */
const option = (value: string): SelectFieldOption => {
  return {
    value: value,
    name: value,
  };
};
/**
 * A shortcut that maps the passed string value to value field
 * and uses baseKey + value to return translation for the name
 * @param value
 * @param t
 * @param baseKey
 */
const optionWithTranslation = (value: string, t: TFunction, baseKey: string): SelectFieldOption => {
  return {
    value: value,
    name: t(`${baseKey}.${value}`),
  };
};
/**
 * Helper that maps an array of strings or enums to select field options
 * @param array
 * @param t
 * @param baseKey
 */
export const optionArrayMapper = (
  array: string[],
  t?: TFunction,
  baseKey?: string,
): SelectFieldOption[] => {
  if (isNil(t) || isNil(baseKey)) {
    return array.map(option);
  } else {
    return array.map((value) => optionWithTranslation(value, t, baseKey));
  }
};

/**
 * Helper that maps an enumerator to select field options
 * @param t
 * @param enumerator
 * @param baseKey
 */
export const optionEnumeratorMapper = (
  enumerator: object,
  t?: TFunction,
  baseKey?: string,
): SelectFieldOption[] => {
  if (isNil(t) || isNil(baseKey)) {
    return Object.keys(enumerator).map(option);
  } else {
    return Object.keys(enumerator).map((value) => optionWithTranslation(value, t, baseKey));
  }
};

/**
 * Helper that maps a language enumerator to select field options
 * @param t
 * @param languageEnum
 * @param baseKey
 */
export const languageOptionEnumMapper = (
  languageEnum: object,
  t?: TFunction,
  baseKey?: string,
): SelectFieldOption[] => {
  if (isNil(t) || isNil(baseKey)) {
    return Object.keys(languageEnum).map(option);
  } else {
    return Object.values(languageEnum).map((value) => optionWithTranslation(value, t, baseKey));
  }
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/components/select.helper.tsx